/* Personalized PDP mobile sticky bar — see snippets/personalized-sticky-bar.liquid
   (the `trc-sticky-bar` class is added by personalized-sticky-bar-init.js) */
(function () {
  var bar = document.querySelector('[data-trc-sb]');
  if (!bar) return;
  var html = document.documentElement;
  var btnPreview = bar.querySelector('[data-trc-sb-preview]');
  var btnAtc = bar.querySelector('[data-trc-sb-atc]');

  function sdkPreview() { return document.querySelector('#personalized-form .btn-preview'); }
  function sdkAtc() { return document.querySelector('#personalized-form .btn-add-to-cart'); }
  function track(action) {
    try { ga('send', 'event', 'Sticky Bar', action, 'personalized'); } catch (e) {}
  }

  /* ---- Buttons proxy the SDK's real Preview / Add to cart ---- */
  btnPreview.addEventListener('click', function () {
    track('Clicked Preview');
    var b = sdkPreview(); if (b) b.click();
  });
  btnAtc.addEventListener('click', function () {
    track('Clicked Add To Cart');
    var b = sdkAtc(); if (b) b.click();
  });

  /* ---- Mirror the SDK ATC's loading state; observe it to toggle the bar ---- */
  function arm() {
    var atc = sdkAtc();
    if (!atc || atc._trcSbArmed) return !!atc;
    atc._trcSbArmed = true;
    var form = document.getElementById('personalized-form');
    if ('MutationObserver' in window) {
      var sync = function () { btnAtc.classList.toggle('is-loading', !!atc.disabled); };
      new MutationObserver(sync).observe(atc, { attributes: true, attributeFilter: ['disabled'] });
      sync();
    }
    // Show the bar while the SDK ATC is out of view (same as v4), with hysteresis: as a scroll
    // settles iOS Safari's toolbar resizes the viewport by ~80px, which flipped a single
    // in-view edge test back and forth (bar flicker) when the ATC sat near the bottom edge.
    // Show only once the ATC has fully left the viewport; hide only once it is fully clear
    // of the bar (bottom) or of the top edge.
    var shown = null, atEnd = false, reached = !form, stage = null, pastStage = false, ticking = false;
    function apply() {
      var on = !!shown && !atEnd && (stage ? pastStage : reached);
      bar.classList.toggle('is-visible', on);
      html.classList.toggle('trc-sb-shown', on);
    }
    function setShown(on) {
      if (on === shown) return;
      shown = on;
      apply();
    }
    // Never cover the footer: hide the bar once the footer comes on screen, show it again only
    // once the footer is 90px below the fold (same hysteresis as the form, for the iOS toolbar).
    // The <footer> itself, not #shopify-section-footer — that also wraps the newsletter block
    // above it, which hid the bar too early.
    var footer = document.querySelector('#shopify-section-footer footer.footer') || document.querySelector('footer.footer');
    function checkFooter(vh) {
      if (!footer) return;
      var t = footer.getBoundingClientRect().top;
      var on = atEnd ? t < vh + 90 : t < vh;
      if (on !== atEnd) { atEnd = on; apply(); }
    }
    // Freshchat launcher is hidden while the personalization form is on screen (CSS), shown again
    // once it has scrolled past. Same hysteresis idea: enter when >90px of it is visible, leave
    // only when it has fully left — wider than the ~80px iOS toolbar resize.
    // Fallback gate when there is no preview gallery (see checkStage): wait until the shopper
    // has scrolled down to the form — on landing nothing is customized yet. Shown once >90px of the
    // form is on screen (or it has been scrolled past); hidden again once it is fully below the fold.
    var formIn = false;
    function checkForm(vh) {
      var f = form && form.getBoundingClientRect();
      if (!f || !f.height) return;
      var on = formIn ? (f.top < vh && f.bottom > 0) : (f.top < vh - 90 && f.bottom > 90);
      if (on !== formIn) { formIn = on; html.classList.toggle('trc-sb-form-in-view', on); }
      var r = reached ? f.top < vh : f.top < vh - 90;
      if (r !== reached) { reached = r; apply(); }
    }
    // Show the bar once the preview gallery has scrolled entirely above the viewport — the same
    // rule (and element) the SDK uses to open its sticky live-preview drawer
    // (MobileCanvasTopDrawer.vue: `.customall-product-media`, bottom < 0), but observed here so the
    // bar doesn't depend on the drawer (closing the drawer keeps the bar). The SDK mounts the
    // gallery after load, so it is looked up lazily; until then the reached-the-form gate applies.
    function checkStage() {
      if (stage && !stage.isConnected) { stage = null; apply(); }
      if (!stage) {
        stage = document.querySelector('.customall-product-media');
        if (!stage) return;
        pastStage = null; // gate just switched from the form fallback — always re-apply below
      }
      var on = stage.getBoundingClientRect().bottom < 0;
      if (on !== pastStage) { pastStage = on; apply(); }
    }
    function check() {
      ticking = false;
      var r = atc.getBoundingClientRect(), vh = window.innerHeight;
      checkForm(vh);
      checkStage();
      checkFooter(vh);
      if (!r.height) return; // ATC not rendered (form re-render) — keep the current state
      if (shown) {
        // Bar height for lifting the Freshchat launcher above it (see CSS); changes with the safe area.
        var h = bar.offsetHeight;
        if (h && h + 'px' !== html.style.getPropertyValue('--trc-sb-h')) html.style.setProperty('--trc-sb-h', h + 'px');
        if (r.top >= 0 && r.bottom <= vh - h) setShown(false);
      } else if (shown === false) {
        if (r.top >= vh || r.bottom <= 0) setShown(true);
      } else {
        setShown(r.top >= vh || r.bottom <= 0);
        if (shown) check();
      }
    }
    function queueCheck() {
      if (!ticking) { ticking = true; requestAnimationFrame(check); }
    }
    window.addEventListener('scroll', queueCheck, { passive: true });
    window.addEventListener('resize', queueCheck);
    if (window.visualViewport) window.visualViewport.addEventListener('resize', queueCheck);
    // Back from /cart (bfcache) or a form re-render can move the ATC without a scroll.
    window.addEventListener('pageshow', queueCheck);
    if ('MutationObserver' in window && form) new MutationObserver(queueCheck).observe(form, { childList: true, subtree: true });
    check();
    return true;
  }
  document.addEventListener('customall-script-injected', function () { setTimeout(arm, 500); });
  var _armTries = 0, _armTimer = setInterval(function () {
    if (arm() || ++_armTries > 40) clearInterval(_armTimer);
  }, 500);

  /* ---- Guard the success → /cart redirect gap: the SDK re-enables its button just before it
     navigates to /cart, which would briefly re-arm the sticky ATC (a second add). A successful
     /cart/add means the redirect is imminent, so keep the sticky ATC locked until the page leaves. ---- */
  (function () {
    function commit() { btnAtc.classList.add('is-committing'); }
    function isAdd(u) { return String(u || '').indexOf('/cart/add') > -1; }
    var _fetch = window.fetch;
    if (_fetch) window.fetch = function () {
      var url = (arguments[0] && arguments[0].url) || arguments[0];
      var p = _fetch.apply(this, arguments);
      if (isAdd(url)) p.then(function (r) { if (r && r.ok) commit(); }).catch(function () {});
      return p;
    };
    var _open = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (m, url) {
      if (isAdd(url)) this.addEventListener('load', function () { if (this.status >= 200 && this.status < 300) commit(); });
      return _open.apply(this, arguments);
    };
    // Back from /cart: Safari restores the page from bfcache with the lock still on — release it
    // and re-sync the loading state from the SDK button.
    window.addEventListener('pageshow', function (e) {
      if (!e.persisted) return;
      btnAtc.classList.remove('is-committing');
      var atc = sdkAtc();
      btnAtc.classList.toggle('is-loading', !!(atc && atc.disabled));
    });
  })();
})();
